import * as React from 'react';
import { Controller, Toolbar, MainMenu } from '@tencent/workbench';
import { QuickToolFeature } from './quick-tool-feature';
import { TOOLBAR_ITEMS, MENU_CONFIGS, config } from './config';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType, TDWVer3Type } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ToolbarType } from '@src/js/constant';
import { getVipInfo } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import { tdwReportForVipLinkText } from '@src/framework/frame-pc/components/vip-link-text';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class QuickToolController {
    public constructor(private readonly feature: QuickToolFeature) {
    }

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    public insertDropdown() {
        const ver3 = (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
            .viewableServiceLayer.toolbarStateManager.getToolbarMode() === ToolbarType.SINGLE_TOOLBAR
            ? TDWVer3Type.SINGLE_TOOLBAR
            : TDWVer3Type.DOUBLE_TOOLBAR;
        // 产品要的上报
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.PC_TOOLBAR,
            action: TDWActionType.SHORTCUT_TOOL,
            eventcode: `${TDWOperationType.DOC_PPT}-${TDWModuleType.PC_TOOLBAR}-${TDWActionType.SHORTCUT_TOOL}`,
            ver3,
            ver5: getVipInfo(),
        });
        // 商业化要的上报
        tdwReportForVipLinkText(true);
        return <MainMenu
            align="left" name={config.id} mode="menu" itemStyle={{ width: 166 }} />;
    }

    @Toolbar(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    public shouldHide() {
        return !(appConfigInstance.getConfig(ToolbarFileMenuConfig.quickTool as any) ?? true);
    }
}
